"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NaNDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var NaNDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createNaN: _factoriesAny.createNaN
};
exports.NaNDependencies = NaNDependencies;